<template>
  <div class="shoppe">
    <el-card>
      <el-input v-model.trim="orderLineNum" placeholder="订单号" style="width: 200px" clearable></el-input>
      <el-button class="ml10" @click="manualForcePush('order')" type="primary">重推订单</el-button>
      <el-button @click="manualForcePush('email')" type="primary">重推邮件</el-button>
    </el-card>
    <el-card class="mt20">
      <h2 class="mb10">删除整个店铺的数据<span class="red">（慎用）</span></h2>
      <el-input v-model.trim="vendorId1" placeholder="Vendor ID" style="width: 200px" clearable></el-input>
      <el-button class="ml10" @click="deleteBpByVendorId" type="primary">删除</el-button>
    </el-card>
    <el-card class="mt20">
      <h2 class="mb10">清空整个店铺的库存<span class="red">（慎用）</span></h2>
      <el-input v-model.trim="vendorId2" placeholder="Vendor ID" style="width: 200px" clearable></el-input>
      <el-button class="ml10" @click="clearStockByVendorId" type="primary">删除</el-button>
    </el-card>
    <el-card class="mt20">
      <h2 class="mb10">删除供货价店铺没有supplyPrice的数据<span class="red">（慎用）</span></h2>
      <el-input v-model.trim="vendorId3" placeholder="Vendor ID" style="width: 200px" clearable></el-input>
      <el-button class="ml10" @click="deleteNotExistsSupplyPricePro" type="primary">删除</el-button>
    </el-card>
    <el-card class="mt20">
      <h2 class="mb10">删除product下无sku的数据<span class="red">（慎用）</span></h2>
      <el-input v-model.trim="vendorId4" placeholder="Vendor ID" style="width: 200px" clearable></el-input>
      <el-button class="ml10" @click="deleteNotExistsSkuPro" type="primary">删除</el-button>
    </el-card>
    <el-card class="mt20">
      <h2 class="mb10">清空整个店铺的国家码<span class="red">（慎用）</span></h2>
      <el-input v-model.trim="vendorId5" placeholder="Vendor ID" style="width: 200px" clearable></el-input>
      <el-button class="ml10" @click="cleanVendorCountrySize" type="primary">清空</el-button>
    </el-card>
  </div>
</template>

<script>
import {
  manualForcePushOrder,
  manualForcePushEmail,
  deleteBpByVendorId,
  clearStockByVendorId,
  deleteNotExistsSupplyPricePro,
  deleteNotExistsSkuPro,
  cleanVendorCountrySize,
} from "../../api/trace";

export default {
  data() {
    return {
      orderLineNum: '',
      vendorId1: '',
      vendorId2: '',
      vendorId3: '',
      vendorId4: '',
      vendorId5: '',
    };
  },
  methods: {
    manualForcePush(type) {
      if (!this.orderLineNum) {
        this.$message('请输入订单号');
        return;
      }
      let request = manualForcePushOrder
      if (type === 'email') {
        request = manualForcePushEmail
      }
      request(this.orderLineNum).then(res => {
        if (res.data.success) {
          this.$message.success('重推成功');
          this.orderLineNum = '';
        } else {
          this.$confirm(res.data.data || res.data.message, '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          });
        }
      })
    },
    deleteBpByVendorId() {
      if (!this.vendorId1) {
        this.$message('请输入Vendor ID');
        return;
      }
      deleteBpByVendorId(this.vendorId1).then(res => {
        if (res.data.success) {
          this.$message.success('提交成功');
          this.vendorId1 = '';
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      });
    },
    clearStockByVendorId() {
      if (!this.vendorId2) {
        this.$message('请输入Vendor ID');
        return;
      }
      clearStockByVendorId(this.vendorId2).then(res => {
        if (res.data.success) {
          this.$message.success('提交成功');
          this.vendorId2 = '';
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      });
    },
    deleteNotExistsSupplyPricePro() {
      if (!this.vendorId3) {
        this.$message('请输入Vendor ID');
        return;
      }
      deleteNotExistsSupplyPricePro(this.vendorId3).then(res => {
        if (res.data.success) {
          this.$message.success('提交成功');
          this.vendorId3 = '';
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      });
    },
    deleteNotExistsSkuPro() {
      if (!this.vendorId4) {
        this.$message('请输入Vendor ID');
        return;
      }
      deleteNotExistsSkuPro([this.vendorId4]).then(res => {
        if (res.data.success) {
          this.$message.success('提交成功');
          this.vendorId4 = '';
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      });
    },
    cleanVendorCountrySize() {
      if (!this.vendorId5) {
        this.$message('请输入Vendor ID');
        return;
      }
      cleanVendorCountrySize([this.vendorId5]).then(res => {
        if (res.data.success) {
          this.$message.success('提交成功');
          this.vendorId5 = '';
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mt20 {
  margin-top: 20px;
}
.mb10 {
  margin-bottom: 10px;
}
.red {
  color: red;
}
</style>
